<script>
  /**
   * RiverLinks — renders alphabetized river links with counts.
   *
   * @module RiverLinks
   * @prop {Object<string, Array<Object>>} uniqueRivers - Map of river name to array of waterbody objects.
   */
  export let uniqueRivers
  var i = 1
</script>

<div class="links uk-container-left">
  <div class="list-border uk-flex uk-flex-left uk-grid-small" uk-grid>
    {#each Object.keys(uniqueRivers).sort() as river, i}
      <div class="uk-panel uk-panel-box uk-text-break uk-width-1-6@l uk-width-1-4@m uk-width-1-2@s">
        <span class="uk-badge" uk-tooltip="Indicates how many Hydrographs are displayed below for this waterway."
          >{uniqueRivers[river].length}</span>
        <a href="#river{i}" title={river} uk-scroll>{river}</a>
      </div>
    {/each}
  </div>
</div>

<style>
  .links {
    padding: 0.5em;
    border-top: 1.5px solid #ff8c00;
    border-top-style: solid;
    border-bottom: 1.5px solid #ff8c00;
    border-bottom-style: solid;
  }
  .uk-panel-box {
    padding: 15px;
    background: #eee;
    color: #666;
    border: 1px solid #d5d5d5;
  }
</style>
